import api from "@/api";

export default {
  state: {
    roles: [],
    role: {},
    selectedRole: {},
  },

  getters: {
    roles: (state) => state.roles,
    role: (state) => state.role,

    selectedRole: (state) => state.selectedRole
  },

  mutations: {
    setRoles: (state, data) => {
      state.roles = data;
    },
    setRole: (state, data) => {
      state.role = data;
    },

    setSelectedRole(state, role) {
      state.selectedRole = role;  
    },
  },

  actions: {
    getRoles: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get("/v1/roles");
        const { data: roles } = response.data;
        commit("setRoles", roles);
      } catch (err) {
        console.error(err);
      }
    },

    getRolesByTeam: async ({ commit }, teamId) => {
      try {
        const response = await api({ requiresAuth: true }).get(`/v1/teams/${teamId}/roles`);
        const { data: roles } = response.data;
        commit("setRoles", roles);
      } catch (err) {
        console.error(err);
      }
    },

    getRole: async ({ commit }, id) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/roles/${id}`
        );
        const { data: role } = response.data;
        commit("setRole", role);
      } catch (err) {
        console.error(err);
      }
    },

    updateRole: (_, { id, title, permissions }) =>
      api({ requiresAuth: true }).patch(`/v1/roles/${id}`, {
        title,
        permissions,
      }),

    createRole: async ({ commit }, { title, permissions, team_id }) => {
      try {
        await api({ requiresAuth: true }).post("/v1/roles", {
          title,
          permissions,
          team_id
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: "Role created successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
